/// <reference types="jquery" />

import { Requestor } from "@openid/appauth/built/xhr";
import { AppAuthError } from "@openid/appauth/built/errors";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class AngularRequestor extends Requestor {

  constructor(private http: HttpClient) {
    super();
  }

  xhr<T>(settings: JQueryAjaxSettings): Promise<T> {
    if (settings.method == undefined) {
      settings.method = "GET";
    }
    return this.http.request<T>(settings.method, settings.url, {
      body: settings.data,
      headers: settings.headers,
    }).toPromise();
  }
}
